<template>
  <div class="dialog-backdrop">
    <slot name="msg" />
    <div
      v-click-outside="() => $emit('close')"
      class="dialog"
      @keydown.esc="$emit('close')"
    >
      <header>
        <div
          v-if="$listeners && this.$listeners.back"
          class="header-button-left"
          :class="{ backNotPresent: !back }"
        >
          <img
            v-if="$listeners && this.$listeners.back"
            src="@/assets/ico/arrow-back-blue.svg"
            @click="$emit('back')"
          >
        </div>
        <div class="header-title">
          <slot name="title" />
          <slot name="subtitle" />
        </div>
        <div
          class="header-button-close"
          title="Close window"
          @click="$emit('close')"
        >
          <img src="@/assets/ico/close-L.svg">
        </div>
        
      </header>
      
      <slot name="body" />
      <slot
        name="footer"
        class="footer"
      />
      
    </div>
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    back: {
      type: Boolean,
      default: true,
    },
  },
  created() {
    window.addEventListener(
      'keyup',
      function(event) {
        // If  ESC key was pressed...
        if (event.keyCode === 27) {
          this.$emit('close')
        }
      }.bind(this),
    )
  },
}
</script>

<style lang="scss" scoped>
.dialog-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background-color: rgba(3, 13, 70, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog {
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // instead ^^ using flex positioning – transform can render elements out of pixel grid (eg. edges of input fields becomes blurry)
    padding: 0 30px;
    width: 580px;
    max-height: 100vh;
    // overflow: auto;
    @include respond-below(sm) {
      width: 94%;
      padding: 0 20px;
    }
    background: white;
    header {
      display: flex;
      justify-content: space-between;
      align-items: top;
      padding-top: 26px;
      .header-title {
        flex: 1;
        //margin-left: 10px;
        @include respond-below(sm) {
          margin-left: 0;
        }
        h4 {
          margin-top: 0;
          margin-bottom: 24px;
          line-height: 36px;
        }
      }
      .header-button-left {
        margin-top: 5px;
        //margin-left: 26px;
        margin-left: 30px;

        cursor: pointer;
        &.backNotPresent {
          opacity: 0;
        }
      }
      .header-button-close {
        margin-top: 5px;
        margin-right: -4px;
        width: 24px;
        height: 24px;
        box-sizing: content-box;
        line-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s ease-in-out;

        cursor: pointer;
        &:hover {
          opacity: 0.5;
        }
      }
    }
    footer {
      margin-top: 36px;
      text-align: center;
      padding-bottom: 36px;
      button {
        width: 200px;
      }
    }

  }
}
</style>
